import { driver } from 'driver.js';

const driverObj = driver();

const initNode = (node) => {
  driverObj.highlight({
    element: `#${node.getAttribute('data-target')}`,
    popover: {
      title:        node.getAttribute('data-title'),
      description:  node.getAttribute('data-description'),
      position:     'top',
      closeBtnText: 'Закрыть подсказку',
    },
  });
};

const delegateClickToToggle = (event) => {
  const node = event.target.closest('.add-material-tour');
  if (!node) return;
  event.preventDefault();
  setTimeout(() => { initNode(node); }, 50);
};

const start = () => {
  document.addEventListener('click', delegateClickToToggle);
};

export default { start };
